import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../lib/supabase';
import { Plus, Pencil, Trash2, X, Save } from 'lucide-react';

const LANGS = ['pt-BR', 'en', 'it'];
const JsonInput = ({ label, value, onChange }) => (
  <div className="space-y-2">
    <label className="block text-gray-300 text-xs font-semibold uppercase tracking-wide">{label}</label>
    {LANGS.map(lang => (
      <div key={lang} className="flex items-center space-x-2">
        <span className="text-gray-500 text-xs w-10">{lang}</span>
        <input value={(value && value[lang]) || ''} onChange={e => onChange({ ...value, [lang]: e.target.value })}
          className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400" />
      </div>
    ))}
  </div>
);

const LanguagesAdmin = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ language: {}, level: {}, flag: '', sort_order: 0 });

  const fetch = useCallback(async () => {
    const { data } = await supabase.from('languages_spoken').select('*').order('sort_order');
    setItems(data || []);
  }, []);
  useEffect(() => { fetch(); }, [fetch]);

  const save = async () => {
    const payload = { ...form }; delete payload.id;
    if (editing === 'new') await supabase.from('languages_spoken').insert(payload);
    else await supabase.from('languages_spoken').update(payload).eq('id', editing);
    setEditing(null); fetch();
  };

  const remove = async (id) => {
    if (!window.confirm('Remover?')) return;
    await supabase.from('languages_spoken').delete().eq('id', id); fetch();
  };

  if (editing) {
    return (
      <div>
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-white">{editing === 'new' ? 'Novo Idioma' : 'Editar Idioma'}</h1>
          <button onClick={() => setEditing(null)} className="text-gray-400 hover:text-white"><X size={24} /></button>
        </div>
        <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 space-y-6 max-w-lg">
          <JsonInput label="Idioma" value={form.language} onChange={v => setForm({...form, language: v})} />
          <JsonInput label="Nível" value={form.level} onChange={v => setForm({...form, level: v})} />
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-gray-300 text-xs font-semibold uppercase mb-2">Bandeira (emoji)</label>
              <input value={form.flag} onChange={e => setForm({...form, flag: e.target.value})}
                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400" placeholder="🇧🇷" /></div>
            <div><label className="block text-gray-300 text-xs font-semibold uppercase mb-2">Ordem</label>
              <input type="number" value={form.sort_order} onChange={e => setForm({...form, sort_order: parseInt(e.target.value) || 0})}
                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400" /></div>
          </div>
          <div className="flex space-x-4">
            <button onClick={save} className="px-8 py-3 bg-lime-400 text-black font-bold rounded-full hover:bg-lime-300 flex items-center space-x-2"><Save size={18} /><span>Salvar</span></button>
            <button onClick={() => setEditing(null)} className="px-8 py-3 border border-gray-600 text-gray-300 rounded-full">Cancelar</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Idiomas</h1>
        <button onClick={() => { setEditing('new'); setForm({ language: {}, level: {}, flag: '', sort_order: items.length + 1 }); }} className="flex items-center space-x-2 px-4 py-2 bg-lime-400 text-black font-bold rounded-full hover:bg-lime-300 text-sm"><Plus size={18} /><span>Novo</span></button>
      </div>
      <div className="space-y-3">
        {items.map(item => (
          <div key={item.id} className="bg-gray-900 border border-gray-800 rounded-xl p-5 flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <span className="text-3xl">{item.flag}</span>
              <div><p className="text-white font-semibold">{item.language?.['pt-BR']}</p><p className="text-gray-400 text-sm">{item.level?.['pt-BR']}</p></div>
            </div>
            <div className="flex space-x-2">
              <button onClick={() => { setEditing(item.id); setForm({...item}); }} className="p-2 text-gray-400 hover:text-lime-400"><Pencil size={14} /></button>
              <button onClick={() => remove(item.id)} className="p-2 text-gray-400 hover:text-red-400"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguagesAdmin;
